import { Vue, Component, Prop } from 'vue-property-decorator';
import { feedbackWidget } from '@/common/widgets';
import { http } from '@/http';
import { MortgageProps } from './types';
import { ModalData } from '@/widgets/FeedbackWidget/types';

@Component
export class MortgageMixin extends Vue implements MortgageProps {
    /**
     *
     */
    @Prop()
    public readonly modalData!: ModalData;
    /**
     *
     */
    @Prop()
    public readonly fetchUrl!: string;
    /**
     *
     */
    public list: any[] = [];
    /**
     *
     */
    public filters: any[] = [];
    /**
     *
     */
    public loadingIndex: number = 0;
    /**
     *
     */
    public get activeFilterItemIndex() {
        return this.filters.findIndex((item) => item.active);
    }
    /**
     *
     */
    public set activeFilterItemIndex(index: number) {
        const oldIndex = this.activeFilterItemIndex;
        this.filters[oldIndex].active = false;
        this.filters[index].active = true;
    }
    /**
     *
     */
    public async fetchData(fetchUrl: string) {
        try {
            const { data } = await http.get(fetchUrl);
            this.list = data.list;
            this.filters = data.filters;
            this.loadingIndex++;
        } catch (error) {
            this.$errorLog(error);
        }
    }
    /**
     *
     */
    public async onFilterItemClick(item: any, index: number) {
        this.$wait.start('fetchList');
        this.activeFilterItemIndex = index;
        await this.fetchData(item.url);
        this.$wait.end('fetchList');
    }
    /**
     *
     */
    public onClickMortgageCard(card: any) {
        const $bank = card;
        const $mortgage = this.filters[this.activeFilterItemIndex];

        const modalData = this.$enrichVars(this.modalData || {}, {
            $bank,
            $mortgage,
        });

        feedbackWidget.show(modalData);
    }
    /**
     *
     */
    public async created() {
        this.$wait.start('fetchData');
        await Promise.all([this.fetchData(this.fetchUrl)]);
        this.$wait.end('fetchData');
    }
}
